const ENV_IDENTIFIERS = {
  dev: 'sorteerpasopladen-o',
  acc: ['sorteerpasopladen-a'],
  local: 'localhost'
};

export const getEnvironment = () => {
  if (typeof window !== 'undefined') {
    const currentUrl = window.location.href;

    const env = Object.keys(ENV_IDENTIFIERS).find(key => {
      const identifiers = ENV_IDENTIFIERS[key];
      if (Array.isArray(identifiers)) {
        return identifiers.some(identifier => currentUrl.includes(identifier));
      } else {
        return currentUrl.includes(identifiers);
      }
    });

    return env || 'prod';
  }
};